export const ExtractionMode = {
  ExtractionMode_ALL: 0,
  ExtractionMode_LARGEST: 1,
  ExtractionMode_SMALLEST: 2,
  ExtractionMode_CUSTOM: 3,
};

export default {
  ExtractionMode,
};
